import { TextField, Typography } from '@mui/material';
import React from 'react';

interface VideoMetadataDialogFieldsProps {
  publicTitle: string;
  onPublicTitleChange: (value: string) => void;
  publicDescription: string;
  onPublicDescriptionChange: (value: string) => void;
  title: string;
  onTitleChange: (value: string) => void;
}

/** Viewer-facing title/description and the admin-only library title, for the video edit dialog. */
export default function VideoMetadataDialogFields({
  publicTitle,
  onPublicTitleChange,
  publicDescription,
  onPublicDescriptionChange,
  title,
  onTitleChange,
}: VideoMetadataDialogFieldsProps) {
  return (
    <>
      <Typography variant="overline" color="text.secondary">
        Shown to viewers
      </Typography>
      <TextField
        autoFocus
        required
        fullWidth
        label="Title"
        helperText="Shown over the video when it plays, unless the card has its own title"
        value={publicTitle}
        onChange={(event) => onPublicTitleChange(event.target.value)}
      />
      <TextField
        required
        fullWidth
        multiline
        minRows={2}
        label="Description"
        value={publicDescription}
        onChange={(event) => onPublicDescriptionChange(event.target.value)}
      />

      <Typography variant="overline" color="text.secondary" sx={{ mt: 1 }}>
        Library (admins only)
      </Typography>
      <TextField
        fullWidth
        label="Library title"
        helperText="How this video is named and searched in the library. Blank uses the viewer title."
        value={title}
        onChange={(event) => onTitleChange(event.target.value)}
      />
    </>
  );
}
